(function () {
  'use strict';
  if (window.KenzaPerformance && window.KenzaPerformance.version === '1.0') return;

  var config = window.KenzaPerformanceConfig || {};
  var measurementId = config.measurementId || 'G-5R7KGTG16X';
  var initialized = false;
  var pending = [];
  var viewTimers = new WeakMap();
  var seenModules = {};
  var firstHomeActionSent = false;

  function clean(value, max) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim().slice(0, max || 100);
  }

  function pathOnly(value) {
    try {
      var url = new URL(value, window.location.origin);
      return clean(url.pathname, 160);
    } catch (_) {
      return clean(String(value || '').split('?')[0].split('#')[0], 160);
    }
  }

  function analyticsAllowed() {
    try {
      return !window.Shopify || !Shopify.customerPrivacy || Shopify.customerPrivacy.analyticsProcessingAllowed();
    } catch (_) {
      return false;
    }
  }

  function loadGtag() {
    if (initialized || !analyticsAllowed()) return;
    initialized = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', measurementId, { send_page_view: false });
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
    document.head.appendChild(script);
    while (pending.length) {
      var item = pending.shift();
      window.gtag('event', item.name, item.params);
    }
  }

  function campaignParams() {
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'campaign_id', 'adset_id', 'ad_id'];
    var params = new URLSearchParams(window.location.search);
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem('kenza_campaign_v1') || '{}'); } catch (_) {}
    keys.forEach(function (key) {
      var value = params.get(key);
      if (value) stored[key] = clean(value, 100);
    });
    try { sessionStorage.setItem('kenza_campaign_v1', JSON.stringify(stored)); } catch (_) {}
    return stored;
  }

  function baseParams() {
    var result = {
      measurement_version: '1.0',
      page_path: pathOnly(window.location.href),
      device_group: window.matchMedia('(max-width: 767px)').matches ? 'mobile' :
        (window.matchMedia('(max-width: 1024px)').matches ? 'tablet' : 'desktop')
    };
    var campaign = campaignParams();
    Object.keys(campaign).forEach(function (key) { result[key] = campaign[key]; });
    return result;
  }

  function emit(name, params) {
    var payload = baseParams();
    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      payload[key] = typeof value === 'number' ? value : clean(value, key === 'destination_path' ? 160 : 100);
    });
    payload.send_to = measurementId;
    if (!initialized) pending.push({ name: name, params: payload });
    loadGtag();
    if (initialized && window.gtag) window.gtag('event', name, payload);
  }

  function destinationType(href) {
    var target = pathOnly(href);
    if (target.indexOf('/collections/') === 0) return 'collection';
    if (target.indexOf('/products/') === 0) return 'product';
    if (target.indexOf('/cart') === 0 || target.indexOf('/checkout') === 0) return 'checkout';
    if (target.indexOf('/pages/') === 0) return 'content';
    if (target.indexOf('/blogs/') === 0) return 'editorial';
    if (target.indexOf('/search') === 0) return 'search';
    return 'other';
  }

  function labelFor(link) {
    return clean(link.getAttribute('data-kenza-home-label') || link.getAttribute('aria-label') || link.textContent, 80);
  }

  function homeModule(element) {
    if (element.closest('.kenza-hero-campana')) return 'hero';
    if (element.closest('.kenza-category-nav')) return 'category_quicklink';
    if (element.closest('.kenza-category-mosaic')) return 'category_mosaic';
    if (element.closest('.kenza-intent-mosaic')) return 'intent_mosaic';
    if (element.closest('.kenza-deco-home')) return 'edesign_module';
    var section = element.closest('.shopify-section');
    var heading = section && section.querySelector('h1,h2,h3');
    return clean(heading ? heading.textContent.toLowerCase() : 'other_home', 60);
  }

  function trackHome() {
    if (window.location.pathname !== '/') return;
    var selectors = ['.kenza-hero-campana', '.kenza-category-nav', '.kenza-category-mosaic', '.kenza-intent-mosaic', '.kenza-deco-home'];
    var modules = document.querySelectorAll(selectors.join(','));
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var moduleName = homeModule(entry.target);
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && !seenModules[moduleName]) {
            var timer = window.setTimeout(function () {
              seenModules[moduleName] = true;
              emit('kenza_home_module_view', { module_name: moduleName, visible_seconds: 1 });
              observer.unobserve(entry.target);
            }, 1000);
            viewTimers.set(entry.target, timer);
          } else if (!entry.isIntersecting && viewTimers.has(entry.target)) {
            window.clearTimeout(viewTimers.get(entry.target));
            viewTimers.delete(entry.target);
          }
        });
      }, { threshold: [0.5] });
      modules.forEach(function (module) { observer.observe(module); });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;
      var moduleName = homeModule(link);
      if (moduleName === 'other_home' && !link.hasAttribute('data-kenza-home-track')) return;
      var params = {
        module_name: moduleName,
        item_label: labelFor(link),
        destination_type: destinationType(link.href),
        destination_path: pathOnly(link.href),
        link_position: Array.prototype.indexOf.call(link.parentElement ? link.parentElement.querySelectorAll(':scope > a') : [], link) + 1
      };
      emit('kenza_home_click', params);
      if (!firstHomeActionSent) {
        firstHomeActionSent = true;
        emit('kenza_home_first_action', params);
      }
    }, { passive: true });
  }

  function trackEdesign() {
    var root = document.querySelector('.kenza-deco-pro');
    if (!root) return;
    emit('edesign_landing_view', { landing_name: 'decoracion_pro', landing_version: 'v1' });

    var sections = root.querySelectorAll('.hero, #que-recibes, .style-strip, #como-funciona, .implementation, #contratar, section');
    if ('IntersectionObserver' in window) {
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
          var sectionName = entry.target.id || (entry.target.className && String(entry.target.className).split(' ')[0]) || 'content';
          sectionName = clean(sectionName, 60);
          var key = 'edesign_' + sectionName;
          if (seenModules[key]) return;
          var timer = window.setTimeout(function () {
            seenModules[key] = true;
            emit('edesign_section_engagement', { section_name: sectionName, visible_seconds: 1 });
            sectionObserver.unobserve(entry.target);
          }, 1000);
          viewTimers.set(entry.target, timer);
        });
      }, { threshold: [0.5] });
      sections.forEach(function (section) { sectionObserver.observe(section); });
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;
      var href = link.href || '';
      var params = {
        cta_label: labelFor(link),
        cta_location: link.closest('header') ? 'hero' : (link.closest('#contratar') ? 'final' : (link.classList.contains('floating-service-cta') ? 'floating' : 'content')),
        destination_path: pathOnly(href)
      };
      if (/whatsapp|wa\.me/i.test(href)) {
        emit('edesign_whatsapp_click', params);
      } else if (/\/cart\/|\/checkout/i.test(href)) {
        emit('edesign_primary_cta_click', params);
        emit('edesign_checkout_start', params);
      } else {
        emit('edesign_primary_cta_click', params);
      }
    }, { passive: true });
  }

  window.KenzaPerformance = { version: '1.0', emit: emit };
  document.addEventListener('visitorConsentCollected', loadGtag);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { loadGtag(); trackHome(); trackEdesign(); });
  } else {
    loadGtag(); trackHome(); trackEdesign();
  }
})();
